// Comprehensive SEO Configuration for Eonixa Dynamics
// Optimized for Google #1 ranking worldwide

export const siteConfig = {
  name: 'Eonixa Dynamics',
  fullName: 'Eonixa Dynamics Private Limited',
  title: 'Eonixa Dynamics',
  url: 'https://www.eonixa.in',
  tagline: 'Government Technology & Infrastructure Solutions',
  description: 'Premier Government Technology, Infrastructure & Digital Transformation Enterprise. ISO 9001, ISO 14001, ISO 45001, ISO 50001, ISO 20000, ISO 27001 Certified. Serving Government, Education & Healthcare Sectors Since 2010.',
  keywords: [
    'government technology solutions',
    'digital transformation India',
    'infrastructure development Maharashtra',
    'smart classroom solutions',
    'project tracking software',
    'budget management system',
    'school furniture India',
    'hospital furniture Pune',
    'IT lab setup',
    'CCTV surveillance systems',
    'enterprise software development',
    'PLM implementation services',
    'IoT consulting services',
    'cloud services India',
    'mobile app development Pune',
    'website development company',
    'ISO certified company Pune',
    'government contractor Maharashtra',
    'education technology solutions',
    'healthcare IT solutions',
    'digital India initiatives',
  ],
  author: 'Eonixa Dynamics Private Limited',
  language: 'en',
  locale: 'en_IN',
}

// Products SEO Data - Each product optimized for ranking
export const productsSEO = {
  software: [
    {
      id: 'project-tracking-app',
      name: 'Project Tracking App',
      title: 'Project Tracking App | Real-time Government Project Monitoring Software',
      description: 'Advanced project tracking software for government and institutional projects. Real-time monitoring, milestone tracking, resource allocation, progress reports. Trusted by 50+ institutions across Maharashtra.',
      keywords: [
        'project tracking software',
        'government project monitoring',
        'real-time project tracking',
        'milestone tracking software',
        'project management app India',
        'government project management system',
        'institutional project tracking',
        'progress tracking software',
        'resource allocation software',
        'project dashboard analytics',
      ],
      features: ['Dashboard Analytics', 'Milestone Tracking', 'Resource Allocation', 'Progress Reports', 'Gantt Charts', 'Budget Tracking'],
      category: 'Software',
    },
    {
      id: 'budget-record-system',
      name: 'Budget Record System (BRS)',
      title: 'Budget Record System | Financial Management Software for Government',
      description: 'Comprehensive budget management system for government institutions. Budget planning, expense tracking, financial reports, audit compliance. ISO certified solution trusted by Maharashtra government.',
      keywords: [
        'budget management system',
        'government budget software',
        'financial management system',
        'expense tracking software',
        'budget planning tool',
        'audit trail software',
        'institutional finance management',
        'government accounting software',
        'budget allocation system',
        'financial reporting software',
      ],
      features: ['Budget Planning', 'Expense Tracking', 'Financial Reports', 'Audit Trail', 'Multi-department Budget', 'Real-time Analytics'],
      category: 'Software',
    },
    {
      id: 'smart-card-application',
      name: 'Smart Card Application',
      title: 'Smart Card Application | Biometric Access Control & Attendance System',
      description: 'Secure smart card solution with biometric authentication, access management, attendance tracking. Government-compliant ID system for institutions. Deployed across 100+ schools and offices.',
      keywords: [
        'smart card system',
        'biometric attendance system',
        'access control software',
        'RFID card system',
        'visitor management system',
        'secure identification',
        'government ID card system',
        'biometric authentication',
        'access management software',
        'institutional security system',
      ],
      features: ['Biometric Authentication', 'Access Control', 'Attendance Tracking', 'Visitor Management', 'Real-time Alerts', 'Multi-location Support'],
      category: 'Software',
    },
    {
      id: 'accounting-finance-suite',
      name: 'Accounting & Finance Suite',
      title: 'Accounting & Finance Suite | Complete Financial Operations Software',
      description: 'All-in-one accounting software with ledger management, invoicing, taxation, financial statements. GST compliant solution for Indian businesses and institutions.',
      keywords: [
        'accounting software India',
        'finance management system',
        'GST compliant software',
        'invoicing software',
        'general ledger system',
        'tax management software',
        'financial statements tool',
        'business accounting software',
        'Indian accounting software',
        'enterprise finance solution',
      ],
      features: ['General Ledger', 'Invoicing', 'Tax Management', 'Financial Statements', 'GST Compliance', 'Multi-currency Support'],
      category: 'Software',
    },
    {
      id: 'construction-management',
      name: 'Construction & Project Management',
      title: 'Construction Project Management Software | Infrastructure Development Tool',
      description: 'End-to-end construction project management for infrastructure projects. Timeline tracking, resource management, cost control, contractor management. Used by government infrastructure departments.',
      keywords: [
        'construction management software',
        'project lifecycle management',
        'infrastructure project tracking',
        'construction timeline software',
        'resource management tool',
        'contractor management system',
        'government construction software',
        'infrastructure development tool',
        'project cost control',
        'construction planning software',
      ],
      features: ['Project Planning', 'Resource Management', 'Timeline Tracking', 'Cost Control', 'Contractor Portal', 'Progress Reports'],
      category: 'Software',
    },
    {
      id: 'hr-inventory-system',
      name: 'Admin, HR & Inventory System',
      title: 'HR & Inventory Management System | Complete Enterprise Solution',
      description: 'Integrated HR management, payroll processing, recruitment, and inventory tracking. Complete enterprise resource planning for institutions. Trusted by schools, colleges, and government offices.',
      keywords: [
        'HR management software',
        'payroll system India',
        'inventory tracking software',
        'employee management system',
        'recruitment software',
        'leave management system',
        'institutional ERP software',
        'HR payroll software',
        'inventory management system',
        'workforce management tool',
      ],
      features: ['Employee Records', 'Payroll Management', 'Inventory Tracking', 'Leave Management', 'Recruitment Module', 'Attendance System'],
      category: 'Software',
    },
    {
      id: 'educational-platform',
      name: 'Educational Platform',
      title: 'Educational Platform | Learning Management System for Schools & Colleges',
      description: 'Complete learning management system with student portal, course management, online exams, progress tracking. Digital education platform for schools, colleges, and universities.',
      keywords: [
        'learning management system',
        'online education platform',
        'student information system',
        'course management software',
        'online exam platform',
        'educational technology',
        'school management software',
        'e-learning platform India',
        'student portal software',
        'digital classroom solution',
      ],
      features: ['Student Portal', 'Course Management', 'Online Exams', 'Progress Tracking', 'Parent Dashboard', 'Teacher Tools'],
      category: 'Software',
    },
    {
      id: 'mobile-applications',
      name: 'Mobile Applications',
      title: 'Mobile App Development | Custom Android & iOS App Development',
      description: 'Custom mobile app development for Android and iOS platforms. Cross-platform solutions with offline support, push notifications, real-time sync. Expert mobile developers in Pune.',
      keywords: [
        'mobile app development',
        'Android app development',
        'iOS app development',
        'cross-platform mobile apps',
        'custom mobile applications',
        'mobile app developers Pune',
        'enterprise mobile apps',
        'mobile software development',
        'app development company India',
        'mobile application solutions',
      ],
      features: ['Cross-Platform', 'Offline Support', 'Push Notifications', 'Real-time Sync', 'Secure APIs', 'App Store Deployment'],
      category: 'Software',
    },
  ],
  infrastructure: [
    {
      id: 'it-labs-setup',
      name: 'IT Labs Setup',
      title: 'IT Lab Setup Services | Computer Lab Installation for Schools & Colleges',
      description: 'Complete computer lab setup with high-performance PCs, networking, educational software. IT infrastructure for schools, colleges, and training institutes. Expert installation across Maharashtra.',
      keywords: [
        'computer lab setup',
        'IT lab installation',
        'school computer lab',
        'college IT infrastructure',
        'computer lab furniture',
        'networking setup',
        'educational software installation',
        'lab equipment suppliers',
        'computer lab services Pune',
        'institutional IT setup',
      ],
      features: ['High-Performance PCs', 'Network Infrastructure', 'Educational Software', 'Technical Support', 'Lab Furniture', 'AC Setup'],
      category: 'Infrastructure',
    },
    {
      id: 'math-robotics-labs',
      name: 'Math & Robotics Labs',
      title: 'Mathematics & Robotics Lab Setup | STEM Education Infrastructure',
      description: 'STEM-focused learning labs with robotics kits, programming tools, experiment stations. Modern mathematics and robotics laboratories for schools and engineering colleges.',
      keywords: [
        'robotics lab setup',
        'STEM lab installation',
        'mathematics laboratory',
        'robotics kits for schools',
        'programming lab',
        'engineering lab equipment',
        'science lab equipment',
        'STEM education infrastructure',
        'robotics education India',
        'practical science lab',
      ],
      features: ['Robotics Kits', 'Programming Tools', 'Experiment Stations', 'STEM Curriculum', 'Safety Equipment', 'Training Support'],
      category: 'Infrastructure',
    },
    {
      id: 'digital-library-system',
      name: 'Digital Library System',
      title: 'Digital Library System | E-Library with Digital Catalog & Management',
      description: 'Modern digital library with e-books, research papers, digital catalog, user management. Complete e-library solution for schools, colleges, and universities.',
      keywords: [
        'digital library system',
        'e-library software',
        'online library platform',
        'digital catalog system',
        'e-books management',
        'research paper database',
        'library management software',
        'digital library India',
        'institutional library system',
        'virtual library platform',
      ],
      features: ['Digital Catalog', 'E-Books Access', 'Research Portal', 'User Management', 'Search & Filter', 'Mobile Access'],
      category: 'Infrastructure',
    },
    {
      id: 'smart-classroom-solutions',
      name: 'Smart Classroom Solutions',
      title: 'Smart Classroom Solutions | Interactive Displays & Digital Teaching Tools',
      description: 'Transform classrooms with interactive flat panels, digital whiteboards, audio systems, content library. Complete smart classroom installation for modern education.',
      keywords: [
        'smart classroom setup',
        'interactive display boards',
        'digital whiteboard',
        'smart class solutions',
        'interactive flat panel',
        'digital teaching tools',
        'classroom technology',
        'educational displays',
        'smart school solutions',
        'digital classroom India',
      ],
      features: ['Interactive Displays', 'Digital Whiteboards', 'Audio Systems', 'Content Library', 'Teacher Training', 'Maintenance Support'],
      category: 'Infrastructure',
    },
    {
      id: 'security-surveillance',
      name: 'Security & Surveillance',
      title: 'CCTV Surveillance Systems | Security Camera Installation & Monitoring',
      description: 'Comprehensive CCTV systems, access control, security monitoring solutions. HD cameras, 24/7 monitoring, mobile alerts for institutions and businesses.',
      keywords: [
        'CCTV installation',
        'security camera systems',
        'surveillance systems',
        'access control installation',
        'security monitoring',
        'HD camera systems',
        'institutional security',
        'video surveillance India',
        'security solutions Pune',
        'CCTV for schools',
      ],
      features: ['HD Cameras', 'Access Control', '24/7 Monitoring', 'Mobile Alerts', 'Night Vision', 'Cloud Storage'],
      category: 'Infrastructure',
    },
    {
      id: 'server-network-infrastructure',
      name: 'Server & Network Infrastructure',
      title: 'Server & Network Infrastructure | Enterprise Data Center Solutions',
      description: 'Enterprise-grade servers, data center setup, network architecture design. Complete IT infrastructure for government departments and large institutions.',
      keywords: [
        'server installation',
        'data center setup',
        'network infrastructure',
        'enterprise servers',
        'network architecture',
        'backup solutions',
        'server room setup',
        'IT infrastructure services',
        'network design India',
        'data center services Pune',
      ],
      features: ['Server Setup', 'Data Center', 'Network Design', 'Backup Solutions', 'Security Systems', '24/7 Support'],
      category: 'Infrastructure',
    },
    {
      id: 'office-furniture',
      name: 'Office Furniture',
      title: 'Office Furniture Suppliers | Ergonomic Desks, Chairs & Workstations',
      description: 'Premium office furniture including ergonomic desks, chairs, workstations, storage solutions. Bulk orders for government offices, schools, and corporate offices.',
      keywords: [
        'office furniture Pune',
        'office chairs',
        'office desks',
        'workstations',
        'ergonomic furniture',
        'office furniture suppliers',
        'corporate furniture',
        'institutional furniture',
        'office furniture India',
        'bulk office furniture',
      ],
      features: ['Ergonomic Design', 'Premium Quality', 'Custom Configurations', 'Bulk Orders', 'Installation Service', 'Warranty Support'],
      category: 'Infrastructure',
    },
    {
      id: 'compactors-storage',
      name: 'Compactors & Storage',
      title: 'Mobile Compactors & Storage Systems | High-Density Filing Solutions',
      description: 'High-density mobile storage systems for files, documents, archival needs. Space-efficient compactors for offices, hospitals, and government departments.',
      keywords: [
        'mobile compactor systems',
        'storage solutions',
        'archival storage',
        'filing systems',
        'high-density storage',
        'document storage',
        'compactor manufacturers',
        'office storage systems',
        'file storage solutions',
        'compact storage India',
      ],
      features: ['Space Efficient', 'Mobile Systems', 'Lockable Units', 'Easy Access', 'Heavy Duty', 'Custom Sizes'],
      category: 'Infrastructure',
    },
    {
      id: 'hospital-furniture',
      name: 'Hospital Furniture',
      title: 'Hospital Furniture Suppliers | Medical-Grade Healthcare Furniture',
      description: 'Medical-grade furniture for hospitals, clinics, healthcare facilities. Patient beds, examination tables, medical cabinets, healthcare seating solutions.',
      keywords: [
        'hospital furniture',
        'medical furniture',
        'healthcare furniture',
        'hospital beds',
        'patient furniture',
        'medical cabinets',
        'examination tables',
        'hospital furniture suppliers',
        'healthcare furniture India',
        'medical furniture Pune',
      ],
      features: ['Medical Grade', 'Easy Sanitization', 'Patient Comfort', 'Durable Build', 'ISO Certified', 'Bulk Supply'],
      category: 'Infrastructure',
    },
    {
      id: 'laboratory-equipment',
      name: 'Laboratory Equipment',
      title: 'Laboratory Equipment Suppliers | Science Lab Setup for Schools & Colleges',
      description: 'Complete science lab equipment, instruments, safety gear for educational institutions. Chemistry, physics, biology lab setup with installation and training.',
      keywords: [
        'laboratory equipment',
        'science lab setup',
        'lab instruments',
        'school laboratory',
        'college lab equipment',
        'chemistry lab',
        'physics lab equipment',
        'biology lab',
        'lab furniture',
        'educational lab suppliers',
      ],
      features: ['Lab Instruments', 'Safety Equipment', 'Chemical Storage', 'Experiment Kits', 'Lab Furniture', 'Training Support'],
      category: 'Infrastructure',
    },
  ],
}

// Services SEO Data
export const servicesSEO = [
  {
    id: 'furniture-solutions',
    name: 'Furniture Solutions',
    title: 'Furniture Solutions | School, Office, Hospital Furniture Supplier',
    description: 'Complete furniture solutions for schools, colleges, offices, hospitals. Classroom furniture, office workstations, medical furniture, storage systems. ISO certified manufacturer.',
    keywords: [
      'furniture suppliers India',
      'school furniture',
      'office furniture',
      'hospital furniture',
      'classroom furniture',
      'laboratory furniture',
      'institutional furniture',
      'furniture manufacturers Pune',
      'bulk furniture orders',
      'custom furniture solutions',
    ],
  },
  {
    id: 'digital-technology',
    name: 'Digital & Technology Solutions',
    title: 'Digital Technology Solutions | Smart Classroom, Software Development, IT',
    description: 'Digital transformation services: smart classrooms, custom software development, IT infrastructure, surveillance systems. Government-approved technology partner.',
    keywords: [
      'digital transformation',
      'smart classroom solutions',
      'software development Pune',
      'IT infrastructure services',
      'CCTV surveillance',
      'digital school program',
      'custom software India',
      'technology solutions',
      'IT services Maharashtra',
      'digital government initiatives',
    ],
  },
  {
    id: 'health-nutrition',
    name: 'Health & Nutrition Solutions',
    title: 'Health & Nutrition Products | Nutrition Bars, Supplements, Meal Programs',
    description: 'Health and nutrition products: millet-based nutrition bars, vitamin supplements, protein products. Mid-Day Meal program support, central kitchen setup solutions.',
    keywords: [
      'nutrition bars',
      'health supplements India',
      'millet products',
      'protein supplements',
      'vitamin supplements',
      'mid-day meal program',
      'central kitchen setup',
      'health food products',
      'nutritional supplements',
      'wellness products',
    ],
  },
  {
    id: 'education-supplies',
    name: 'Education & Academic Supplies',
    title: 'Education Supplies | School Stationery, Books, Learning Materials',
    description: 'Educational supplies: school stationery, academic books, learning materials, digital tablets, educational toys. Complete school supply solutions.',
    keywords: [
      'school stationery',
      'educational supplies',
      'academic books',
      'learning materials',
      'digital tablets for education',
      'educational toys',
      'school supplies India',
      'academic supplies',
      'education materials',
      'stationery suppliers',
    ],
  },
  {
    id: 'infrastructure-development',
    name: 'Infrastructure & Facility Solutions',
    title: 'Infrastructure Development | Flooring, Playground, Gym Setup',
    description: 'Infrastructure solutions: antibacterial vinyl flooring, playground setup, gym installation, institutional development. Complete facility transformation.',
    keywords: [
      'infrastructure development',
      'vinyl flooring',
      'playground setup',
      'gym installation',
      'institutional development',
      'antibacterial flooring',
      'sports facility setup',
      'infrastructure contractors',
      'facility development India',
      'school infrastructure',
    ],
  },
  {
    id: 'mobile-app-development',
    name: 'Mobile Application Development',
    title: 'Mobile App Development Company | Android, iOS, Cross-Platform Apps',
    description: 'Custom mobile app development for Android and iOS. Cross-platform solutions with offline support, push notifications. Expert mobile developers in Pune, India.',
    keywords: [
      'mobile app development',
      'Android app development',
      'iOS app development',
      'cross-platform apps',
      'mobile application company',
      'app developers Pune',
      'custom mobile apps',
      'mobile software development',
      'app development India',
      'mobile solutions',
    ],
  },
  {
    id: 'website-development',
    name: 'Desktop Website Creation',
    title: 'Website Development Company | Responsive Web Design, E-Commerce',
    description: 'Professional website development: responsive web design, e-commerce solutions, CMS development, SEO optimization. Expert web developers in Pune.',
    keywords: [
      'website development',
      'web design company',
      'responsive websites',
      'e-commerce development',
      'CMS development',
      'website designers Pune',
      'web development India',
      'custom website development',
      'SEO optimization',
      'professional websites',
    ],
  },
  {
    id: 'plm-services',
    name: 'Product Lifecycle Management (PLM)',
    title: 'PLM Services | Product Lifecycle Management Implementation & Consulting',
    description: 'Comprehensive PLM services: assessment, implementation, data migration, application management. Enterprise PLM solutions for manufacturing and product companies.',
    keywords: [
      'PLM implementation',
      'product lifecycle management',
      'PLM consulting',
      'PLM software',
      'data migration PLM',
      'PLM services India',
      'product development',
      'PLM solutions',
      'enterprise PLM',
      'PLM assessment',
    ],
  },
  {
    id: 'iot-services',
    name: 'IoT Services',
    title: 'IoT Services | Internet of Things Consulting, Development & Analytics',
    description: 'End-to-end IoT services: strategic consulting, full-cycle development, IoT analytics, application management. Transform business with connected solutions.',
    keywords: [
      'IoT services',
      'Internet of Things',
      'IoT consulting',
      'IoT development',
      'IoT analytics',
      'connected devices',
      'IoT solutions India',
      'IoT application development',
      'smart IoT',
      'IoT implementation',
    ],
  },
  {
    id: 'cloud-services',
    name: 'Cloud Services',
    title: 'Cloud Services | Cloud Advisory, Implementation & Managed Services',
    description: 'Complete cloud services: advisory, enablement, implementation, managed services, Azure IoT Hub. Expert cloud solutions for enterprises.',
    keywords: [
      'cloud services',
      'cloud computing',
      'cloud implementation',
      'cloud managed services',
      'Azure services',
      'AWS cloud',
      'cloud migration',
      'cloud consulting',
      'cloud solutions India',
      'enterprise cloud',
    ],
  },
]

// Pages SEO Configuration
export const pagesSEO = {
  home: {
    title: 'Eonixa Dynamics | Government Technology & Infrastructure Solutions | ISO Certified',
    description: 'Leading Government Technology, Infrastructure & Digital Transformation Enterprise. ISO 9001, ISO 14001, ISO 45001, ISO 50001, ISO 20000, ISO 27001 Certified. Serving Government, Education & Healthcare Sectors Since 2010.',
    keywords: 'government technology, digital transformation, infrastructure solutions, ISO certified, Maharashtra, smart governance, enterprise software, IT infrastructure',
  },
  about: {
    title: 'About Eonixa Dynamics | ISO Certified Government Technology Company',
    description: 'Learn about Eonixa Dynamics - Premier Government Technology & Infrastructure Enterprise with 10+ ISO certifications. Trusted by 50+ institutions across Maharashtra since 2010.',
    keywords: 'about eonixa, government technology company, ISO certified enterprise, technology partner Maharashtra, eonixa history',
  },
  services: {
    title: 'Our Services | Government Technology, Infrastructure & Digital Solutions',
    description: 'Comprehensive services: Furniture, Digital Technology, Health & Nutrition, Education, Infrastructure, Mobile Apps, Websites, PLM, IoT, Cloud Services. Government-approved vendor.',
    keywords: 'government services, digital services, infrastructure services, technology services, enterprise solutions, government vendor',
  },
  products: {
    title: 'Our Products | Software Solutions & Infrastructure Products',
    description: 'Enterprise software products and infrastructure solutions: Project Tracking, Budget Management, Smart Cards, IT Labs, Smart Classrooms, Security Systems. ISO certified products.',
    keywords: 'software products, infrastructure products, enterprise software, IT infrastructure, government products, institutional products',
  },
  contact: {
    title: 'Contact Us | Get Quote for Government Technology Solutions',
    description: 'Contact Eonixa Dynamics for government technology solutions, infrastructure projects, software development. Call +91 8390101555 or email info@eonixa.in. Pune, Maharashtra.',
    keywords: 'contact eonixa, government technology contact, get quote, technology inquiry, Pune contact',
  },
  projects: {
    title: 'Our Projects | Government Technology & Infrastructure Projects',
    description: 'Explore our completed projects across Government, Education, Healthcare sectors. Smart classrooms, IT infrastructure, software implementations across Maharashtra.',
    keywords: 'government projects, completed projects, case studies, technology projects, infrastructure projects',
  },
  certifications: {
    title: 'Certifications | 10 ISO Certifications | Quality & Compliance',
    description: 'Eonixa Dynamics holds 10 ISO certifications including ISO 9001, ISO 14001, ISO 45001, ISO 50001, ISO 20000, ISO 27001. Green Pro, BIFMA certified for quality.',
    keywords: 'ISO certifications, ISO 9001, ISO 14001, ISO 45001, ISO 50001, ISO 20000, ISO 27001, quality certification, Green Pro, BIFMA',
  },
}

// Structured Data Generators
export const generateOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Eonixa Dynamics Private Limited',
  alternateName: 'Eonixa Dynamics',
  url: 'https://www.eonixa.in',
  logo: 'https://www.eonixa.in/logo.png',
  description: 'Premier Government Technology, Infrastructure & Digital Transformation Enterprise',
  foundingDate: '2010',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Sky Iris, Bavdhan',
    addressLocality: 'Pune',
    addressRegion: 'Maharashtra',
    postalCode: '411001',
    addressCountry: 'IN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-8390101555',
    contactType: 'Customer Service',
    areaServed: 'IN',
    availableLanguage: ['English', 'Hindi', 'Marathi'],
  },
  sameAs: [
    'https://www.linkedin.com/company/eonixa-dynamics',
    'https://twitter.com/eonixadynamics',
  ],
  awards: [
    'ISO 9001:2015 IAF-3',
    'ISO 14001:2015 IAF',
    'ISO 45001:2018 IAF',
    'ISO 50001',
    'ISO 20000-1:2018',
    'ISO 27001:2013',
    'AIOTA',
    'BIFMA',
    'Green Pro',
    'Green Guard',
  ],
})

export const generateProductSchema = (product: any) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.name,
  description: product.description,
  brand: {
    '@type': 'Brand',
    name: 'Eonixa Dynamics',
  },
  manufacturer: {
    '@type': 'Organization',
    name: 'Eonixa Dynamics Private Limited',
  },
  category: product.category,
  offers: {
    '@type': 'Offer',
    availability: 'https://schema.org/InStock',
    priceCurrency: 'INR',
    seller: {
      '@type': 'Organization',
      name: 'Eonixa Dynamics Private Limited',
    },
  },
})

export const generateServiceSchema = (service: any) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: service.name,
  description: service.description,
  provider: {
    '@type': 'Organization',
    name: 'Eonixa Dynamics Private Limited',
    url: 'https://www.eonixa.in',
  },
  areaServed: {
    '@type': 'Country',
    name: 'India',
  },
  serviceType: service.title,
})

export const generateLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Eonixa Dynamics Private Limited',
  image: 'https://www.eonixa.in/logo.png',
  '@id': 'https://www.eonixa.in',
  url: 'https://www.eonixa.in',
  telephone: '+91-8390101555',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Sky Iris, Bavdhan',
    addressLocality: 'Pune',
    addressRegion: 'Maharashtra',
    postalCode: '411001',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 18.5204,
    longitude: 73.8567,
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00',
  },
  priceRange: '$$',
})

export const generateBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `https://www.eonixa.in${item.url}`,
  })),
})

export const generateFAQSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(faq => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
})